/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

import _ from 'lodash';
import React from 'react';
import { observer } from 'mobx-react';
import { Icon, Button } from 'semantic-ui-react';

// expected props
// - error (an object with a "message" property  or a string)
// - onRetry (via prop) a call back function
// - onCancel (via prop) a call back function
// - className
class ErrorBox extends React.Component {
  handleRetry = () => {
    Promise.resolve()
      .then(() => this.props.onRetry())
      .catch(_err => {
        /* ignore */
      });
  };

  render() {
    const defaultMessage = 'Hmm... something went wrong';
    const rawMessage = this.props.error || defaultMessage;
    let message = _.isString(rawMessage) ? rawMessage : _.get(rawMessage, 'message', defaultMessage);

    // If the API returned raw HTML (e.g. service unavailable), show a friendly message instead
    if (message && (message.includes('<!DOCTYPE') || message.includes('<html'))) {
      message = 'Service currently unavailable. Please try again shortly.';
    }

    const shouldRetry = _.isFunction(this.props.onRetry);
    const shouldCancel = _.isFunction(this.props.onCancel);
    const className = this.props.className || '';

    return (
      <div className={className}>
        <div className="workspace-empty-state">
          <div className="workspace-empty-state-icon workspace-empty-state-icon-error">
            <Icon name="exclamation triangle" />
          </div>
          <div className="workspace-empty-state-title">A problem was encountered</div>
          <div className="workspace-empty-state-subtitle">{message}</div>
          <div className="workspace-empty-state-actions">
            {shouldRetry && (
              <Button color="blue" basic onClick={this.handleRetry}>
                <Icon name="redo" /> Retry
              </Button>
            )}
            {shouldCancel && (
              <Button basic onClick={this.props.onCancel}>
                Dismiss
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default observer(ErrorBox);
